/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect, useState } from 'react';

interface SwitchProps {
    value: any,
    items: { value: any, label: string, icon: JSX.Element }[],
    onChange?: (value: any) => void,
}

export function Switch({ value, items, onChange }: SwitchProps) {
    const [active, setActive] = useState(value);

    useEffect(() => {
        setActive(value);
    }, [value]);

    return (
        <div className="main__header-controls">
            {items.map(item => {
                return (
                    item.value === active
                        ?
                        <span key={item.value} className="main__header-controls-item _active" title={item.label}>
                            {item.icon}
                        </span>
                        :
                        <a
                            key={item.value}
                            href={`#${item.value}`}
                            className="main__header-controls-item"
                            title={item.label}
                            onClick={(e) => {
                                e.preventDefault();
                                setActive(item.value);
                                onChange && onChange(item.value);
                            }}>
                            {item.icon}
                        </a>
                );
            })}
        </div>
    );
}